// ---- Water: underwater scene + bubble layers ----
(function(){
  const cv = document.getElementById('su');
  const on = document.getElementById('su2');
  if (!cv || !cv.getContext) return;
  const ctx = cv.getContext('2d');
  const octx = on && on.getContext ? on.getContext('2d') : null;
  const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const R = (a,b) => a + Math.random()*(b-a);
  let W, H, mobil;

  function boyutla(){
    const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    W = window.innerWidth; H = window.innerHeight;
    [cv, on].forEach(k => {
      if (!k) return;
      k.width = Math.round(W*dpr); k.height = Math.round(H*dpr);
      k.style.width = W+'px'; k.style.height = H+'px';
    });
    ctx.setTransform(dpr,0,0,dpr,0,0);
    if (octx) octx.setTransform(dpr,0,0,dpr,0,0);
    mobil = W < 700;
  }
  boyutla();
  window.addEventListener('resize', boyutla);

  const kabarcik = [], kar = [], raylar = [], kostik = [];
  const KMAX = innerWidth < 700 ? 48 : 84;
  for (let i=0; i<(innerWidth<700?11:16); i++) kabarcik.push({tip:'genel', x:R(0,1), y:R(0,1), r:R(2.4,9), h:R(.5,1.1), f:R(0,6.28), s:R(.01,.024)});
  for (let i=0; i<(innerWidth<700?14:26); i++) kar.push({x:R(0,1), y:R(0,1), r:R(.7,1.8), h:R(.15,.4), f:R(0,6.28)});
  for (let i=0; i<(innerWidth<700?3:4); i++) raylar.push({x:R(.1,.92), gen:R(.08,.18), egim:R(-.16,.16), f:R(0,6.28), a:R(.06,.11)});
  for (let i=0; i<(innerWidth<700?4:7); i++) kostik.push({x:R(0,1), y:R(.02,.55), r:R(.16,.4), f:R(0,6.28), fx:R(.04,.12), fy:R(.03,.09), a:R(.04,.06)});

  const kaynaklar = (innerWidth<700 ? [.3,.74] : [.18,.52,.84]).map(x => ({x:x+R(-.05,.05), aralik:R(26,46), sayac:R(0,30)}));

  function kabarcikCiz(c, x, y, r, alfa){
    if (r > 4.5){
      const bg = c.createRadialGradient(x-r*.3, y-r*.3, r*.1, x, y, r);
      bg.addColorStop(0, 'rgba(255,255,255,' + (.26*alfa).toFixed(3) + ')');
      bg.addColorStop(.75, 'rgba(200,214,255,' + (.05*alfa).toFixed(3) + ')');
      bg.addColorStop(1, 'rgba(200,214,255,0)');
      c.fillStyle = bg;
      c.beginPath(); c.arc(x,y,r,0,6.283); c.fill();
    }
    c.strokeStyle = 'rgba(198,210,255,' + (.36*alfa).toFixed(3) + ')';
    c.lineWidth = 1;
    c.beginPath(); c.arc(x,y,r,0,6.283); c.stroke();
    c.fillStyle = 'rgba(255,255,255,' + (.26*alfa).toFixed(3) + ')';
    c.beginPath(); c.arc(x-r*.35, y-r*.35, Math.max(.5,r*.26), 0, 6.283); c.fill();
  }

  let hedef = [186,168,255], su = [186,168,255], kare = 0;
  function neonOku(){
    const v = getComputedStyle(document.documentElement).getPropertyValue('--neon-rgb').trim().split(',').map(Number);
    if (v.length === 3 && v.every(n => !isNaN(n))) hedef = v;
  }
  neonOku();

  function ciz(t){
    const sy = window.scrollY || 0;
    const belge = Math.max(document.documentElement.scrollHeight - H, 1);
    const derinlik = Math.min(1, sy/(belge*.75));
    for (let i=0;i<3;i++) su[i] += (hedef[i]-su[i])*.045;
    const nr = su[0]|0, ng = su[1]|0, nb = su[2]|0;

    const ust = 1 - derinlik*.6;
    const g = ctx.createLinearGradient(0,0,0,H);
    g.addColorStop(0, 'rgb(' + Math.round(24+nr*.11*ust) + ',' + Math.round(28+ng*.11*ust) + ',' + Math.round(56+nb*.15*ust) + ')');
    g.addColorStop(.55, '#0d1434');
    g.addColorStop(1, '#0a0f28');
    ctx.fillStyle = g; ctx.fillRect(0,0,W,H);

    ctx.globalCompositeOperation = 'lighter';

    const yuzey = Math.max(0, 1 - sy/420);
    if (yuzey > .02){
      const yg = ctx.createLinearGradient(0,0,0,H*.16);
      yg.addColorStop(0, 'rgba(' + nr + ',' + ng + ',' + nb + ',' + (.18*yuzey).toFixed(3) + ')');
      yg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = yg; ctx.fillRect(0,0,W,H*.16);
      ctx.beginPath();
      for (let x=0; x<=W; x+=14){
        const y = 13 + Math.sin(x*.02 + t*.0011)*3 + Math.sin(x*.007 - t*.0007)*4;
        x === 0 ? ctx.moveTo(x,y) : ctx.lineTo(x,y);
      }
      ctx.strokeStyle = 'rgba(' + nr + ',' + ng + ',' + nb + ',' + (.34*yuzey).toFixed(3) + ')';
      ctx.lineWidth = 1.4; ctx.stroke();
    }

    const rayA = 1 - derinlik*.55;
    raylar.forEach(r => {
      const sal = Math.sin(t*.00045 + r.f)*.05;
      const x0 = (r.x + sal*.4)*W, gen = r.gen*W, kay = (r.egim + sal)*H;
      const lg = ctx.createLinearGradient(x0, 0, x0 + kay, H*.92);
      lg.addColorStop(0, 'rgba(' + nr + ',' + ng + ',' + nb + ',' + (r.a*rayA).toFixed(3) + ')');
      lg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = lg;
      ctx.beginPath();
      ctx.moveTo(x0-gen*.25, 0); ctx.lineTo(x0+gen*.25, 0);
      ctx.lineTo(x0+kay+gen*.7, H*.92); ctx.lineTo(x0+kay-gen*.7, H*.92);
      ctx.closePath(); ctx.fill();
    });

    kostik.forEach(c => {
      const cx = (c.x + Math.sin(t*.0001 + c.f)*c.fx)*W;
      const cy = (c.y + Math.cos(t*.00008 + c.f)*c.fy)*H;
      const cr = Math.max(1, c.r*Math.min(W,H)*(1 + Math.sin(t*.0002 + c.f)*.15));
      const rg = ctx.createRadialGradient(cx,cy,0,cx,cy,cr);
      rg.addColorStop(0, 'rgba(' + nr + ',' + ng + ',' + nb + ',' + (c.a*(1-derinlik*.4)).toFixed(3) + ')');
      rg.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = rg;
      ctx.beginPath(); ctx.arc(cx,cy,cr,0,6.283); ctx.fill();
    });

    ctx.globalCompositeOperation = 'source-over';

    kar.forEach(k => {
      k.y += k.h*.0004; if (k.y > 1.02){ k.y = -.02; k.x = Math.random(); }
      const x = (k.x + Math.sin(t*.0003 + k.f)*.01)*W;
      ctx.fillStyle = 'rgba(208,216,255,' + (.08 + k.h*.4).toFixed(3) + ')';
      ctx.beginPath(); ctx.arc(x, k.y*H, k.r, 0, 6.283); ctx.fill();
    });

    kaynaklar.forEach(k => {
      if (++k.sayac >= k.aralik){
        k.sayac = 0; k.aralik = R(26,48);
        if (kabarcik.length >= KMAX){
          const i = kabarcik.findIndex(b => b.tip === 'akis');
          if (i > -1) kabarcik.splice(i,1);
        }
        kabarcik.push({tip:'akis', x:k.x+R(-.008,.008), y:1.04, r:R(1.4,3.8), h:R(1.2,1.9), f:R(0,6.28), s:R(.02,.045)});
      }
    });

    for (let i=kabarcik.length-1; i>=0; i--){
      const b = kabarcik[i];
      b.y -= b.h*.0011; b.f += b.s;
      if (b.y < -.04){
        if (b.tip === 'akis'){ kabarcik.splice(i,1); continue; }
        b.y = 1.05; b.x = Math.random();
      }
      const x = (b.x + Math.sin(b.f)*(b.tip === 'akis' ? .006 : .012))*W;
      kabarcikCiz(ctx, x, b.y*H, b.r, 1);
    }

    if (++kare % 20 === 0) neonOku();
  }

  const parmak = [];
  function dogur(x,y,r,vx,vy){
    if (parmak.length > 90) parmak.shift();
    parmak.push({x,y,r,vx,vy,f:R(0,6.28),yas:0,omur:R(55,110)});
  }
  let sonX = null, sonY = null, birikim = 0;
  if (octx && !azHareket){
    window.addEventListener('pointermove', e => {
      if (sonX !== null) birikim += Math.hypot(e.clientX-sonX, e.clientY-sonY);
      sonX = e.clientX; sonY = e.clientY;
      while (birikim > 24){
        birikim -= 24;
        dogur(e.clientX+R(-7,7), e.clientY+R(-4,10), R(1.3,4.2), R(-.25,.25), R(-1,-.45));
      }
    }, {passive:true});
    window.addEventListener('pointerdown', e => {
      for (let i=0;i<10;i++) dogur(e.clientX+R(-5,5), e.clientY+R(-3,7), R(1.5,4.8), R(-.8,.8), R(-1.8,-.5));
    }, {passive:true});
  }
  function onCiz(){
    if (!octx) return;
    octx.clearRect(0,0,W,H);
    for (let i=parmak.length-1; i>=0; i--){
      const p = parmak[i];
      p.yas++;
      if (p.yas >= p.omur || p.y < -12){ parmak.splice(i,1); continue; }
      p.vy = Math.max(p.vy - .028, -2.1);
      p.x += p.vx + Math.sin((p.yas + p.f*10)*.14)*.34;
      p.y += p.vy;
      p.vx *= .97;
      kabarcikCiz(octx, p.x, p.y, p.r, 1 - p.yas/p.omur);
    }
  }

  if (azHareket){ ciz(0); window.addEventListener('resize', () => ciz(0)); return; }
  (function dongu(t){ ciz(t || 0); onCiz(); requestAnimationFrame(dongu); })();
})();


// ---- Light picker: preloads photos, waits for decode, swaps without flicker ----
const paletler = document.querySelectorAll('.palet');
const isikFoto = document.getElementById('isikFoto');
const isikAd = document.getElementById('isikAd');
let secimNo = 0;

function fotolariOnYukle(){
  paletler.forEach(p => { const im = new Image(); im.decoding = 'async'; im.src = p.dataset.img; });
}
if ('requestIdleCallback' in window) requestIdleCallback(fotolariOnYukle, { timeout: 4000 });
else setTimeout(fotolariOnYukle, 1500);

paletler.forEach(p => {
  p.addEventListener('click', () => {
    paletler.forEach(x => x.setAttribute('aria-pressed','false'));
    p.setAttribute('aria-pressed','true');
    document.documentElement.style.setProperty('--neon-rgb', p.dataset.rgb);
    if (p.dataset.vid) {
      const pv = document.getElementById('paketVid');
      if (pv) pv.value = p.dataset.vid;
    }

    const no = ++secimNo;
    isikFoto.classList.add('soluk');
    const yeni = new Image();
    yeni.decoding = 'async';
    yeni.src = p.dataset.img;
    const uygula = () => {
      if (no !== secimNo) return;
      isikFoto.src = yeni.src;
      isikAd.textContent = p.dataset.ad;
      requestAnimationFrame(() => requestAnimationFrame(() => isikFoto.classList.remove('soluk')));
    };
    if (yeni.decode) { yeni.decode().then(uygula).catch(uygula); }
    else { yeni.onload = uygula; yeni.onerror = uygula; }
  });
});

// ---- Bundle picker: quantity + price display (colour variant comes from the light picker) ----
const paketler = document.querySelectorAll('.paket');
const paketCta = document.getElementById('paketCta');
const yFiyat = document.getElementById('yapiskanFiyat');
const yEski = document.getElementById('yapiskanEski');
const heroFiyat = document.getElementById('heroFiyat');
paketler.forEach(p => {
  p.addEventListener('click', () => {
    paketler.forEach(x => x.setAttribute('aria-pressed','false'));
    p.setAttribute('aria-pressed','true');
    paketCta.firstChild.textContent = p.dataset.fiyat + ' — Secure Checkout ';
    yFiyat.textContent = p.dataset.fiyat;
    yEski.textContent = p.dataset.eski;
    document.getElementById('paketQty').value = p.dataset.qty;
  });
});

// ---- Anatomy: photo markers ↔ feature list ----
const isaretler = document.querySelectorAll('.isaret');
const anatomiSatirlar = document.querySelectorAll('.anatomi-liste li');
let anatomiZaman = null, anatomiElle = false, anatomiNo = 1;
function anatomiSec(no){
  const s = String(no);
  anatomiNo = Number(no);
  isaretler.forEach(b => b.classList.toggle('aktif', b.dataset.no === s));
  anatomiSatirlar.forEach(l => l.classList.toggle('aktif', l.dataset.no === s));
}
function anatomiDurdur(){ anatomiElle = true; clearInterval(anatomiZaman); anatomiZaman = null; }
isaretler.forEach(b => b.addEventListener('click', () => { anatomiDurdur(); anatomiSec(b.dataset.no); }));
anatomiSatirlar.forEach(l => l.addEventListener('click', () => { anatomiDurdur(); anatomiSec(l.dataset.no); }));
const anatomiKutu = document.querySelector('.anatomi');
if (anatomiKutu && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const anatomiIo = new IntersectionObserver(([g]) => {
    if (anatomiElle) { anatomiIo.disconnect(); return; }
    if (g.isIntersecting && !anatomiZaman) {
      anatomiZaman = setInterval(() => anatomiSec(anatomiNo % 5 + 1), 3400);
    } else if (!g.isIntersecting) { clearInterval(anatomiZaman); anatomiZaman = null; }
  }, { threshold: .3 });
  anatomiIo.observe(anatomiKutu);
}


// ---- Scroll reveal ----
const io = new IntersectionObserver(girisler => {
  girisler.forEach(g => { if (g.isIntersecting) { g.target.classList.add('icinde'); io.unobserve(g.target); } });
}, { threshold: .12 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// ---- Sticky bar: shows after the hero ----
const yapiskan = document.getElementById('yapiskan');
const hero = document.querySelector('.hero');
const heroIo = new IntersectionObserver(([g]) => {
  yapiskan.classList.toggle('goster', !g.isIntersecting);
}, { threshold: 0 });
heroIo.observe(hero);
